import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_BATCHES_REQUEST, fetchBatchesSuccess, fetchBatchesFailure } from '../actions/batchGroupActions';
import axios from 'axios';

function* fetchBatchesSaga() {
  try {
    const response = yield call(axios.get, '/sampleBacthGroup.json');
    yield put(fetchBatchesSuccess(response.data));
  } catch (error) {
    yield put(fetchBatchesFailure(error));
  }
}

export function* batchGroup() {
  // yield takeLatest(FETCH_BATCHES_REQUEST, fetchBatchesSaga);
}
